import { CustomAddress, GoogleDestinationWithPlaceId } from "../../../types";
import { SetCustomAddressActions } from "../actions";

type DropoffLocationSelectionState = {
  destinations?: GoogleDestinationWithPlaceId[];
  error: boolean;
  isCustomAddress?: boolean;
  loading: boolean;
  selectedLocation?: GoogleDestinationWithPlaceId | CustomAddress;
};

const INITIAL_STATE: DropoffLocationSelectionState = {
  loading: false,
  destinations: [],
  error: false,
};

export const DropoffLocationSelectionReducer = (
  state: DropoffLocationSelectionState = INITIAL_STATE,
  action: SetCustomAddressActions
): DropoffLocationSelectionState => {
  switch (action.type) {
    case "@@DROPOFF_LOCATION_SELECTION/CLEAR_CUSTOM_ADDRESS":
      return {
        ...state,
        loading: false,
        error: false,
        isCustomAddress: false,
        selectedLocation: null,
      };
    case "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS":
      return {
        ...state,
        loading: true,
      };
    case "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS_ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    case "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        isCustomAddress: true,
        selectedLocation: action.payload,
      };
    case "REFRESH_REDUCERS":
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
